import { render, staticRenderFns } from "./Region-Selector.vue?vue&type=template&id=4db440ed&lang=pug"
import script from "./Region-Selector.vue?vue&type=script&lang=ts"
export * from "./Region-Selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports